import styled from 'styled-components';
import { theme } from '../../../../../consts/theme';

export const StyledEmailDiv = styled.div`
  color: ${theme.colors.white};
  font-size: 16px;
  font-weight: 500;
  text-align: end;
  text-overflow: ellipsis;
  overflow: hidden;
  @media (max-width: 768px) {
    display: none;
  }
`;
